import colors from "vuetify/lib/util/colors";

// #region Private Methods
/**
 * @summary Verifica se a colorName é alguma dessas cores padrões do tema
 * @param {String} colorName nome da cor
 * @returns {Boolean}
 */
const IsThemeColor = (colorName = "color") =>
{
	const themeColorName = [ "primary", "secondary",
		"accent",
		"error",
		"info",
		"success",
		"warning",
		"background" ];
	const isInclude = themeColorName.includes(colorName);
	return isInclude;
};

/**
 * @summary Pega o thema de acordo com o isDarkMode
 * @param {String} colorName - Nome da cor. ex: primary, secundary, etc...
 * @param {Object} themeColors - Com temas da aplicação.
 * @param {bool} isDarkMode - Está no DarkMode ou não.
 * @returns { String } em hexadecimal das cores.
 */
const GetThemeColor = (colorName, themeColors, isDarkMode) =>
{
	if (isDarkMode) return themeColors.dark[colorName];
	return themeColors.light[colorName];
};

/**
 * @summary Recebe o nome da cor e devolve ela em hexadecimal
 * @param {String} colorName - Nome da cor. ex: red, blue...
 * @param {String} variant  - Nome da variante da cor de cima. ex: darken-1
 * @returns { String } - Nome da cor em hexadecimal
 */
const GetVuetifyColorsByName = (colorName, variant = "base") =>
{
	 const wantedColor = colors[colorName];
	 return wantedColor[variant];
};

// #endregion

// #region Public Methods

/**
 * @summary Filtra o colorName para casos especiais e retorna a cor
 * @param {String} colorName - Nome da cor. ex: primary, secundary, etc...
 * @param {String} variant  - Nome da variante da cor de cima. ex: darken-1
 * @param {Object} themeColors - Com temas da aplicação.
 * @param {Boolean} isDarkMode - Está no DarkMode ou não.
 * @returns {String} retorna a cor em hexadecimal.
 */
export const GetVuetifyColors = (colorName, variant, themeColors, isDarkMode) =>
{
	// Se o cor escrita for uma cor do tema. Retorna em hexadecimal a cor.
	if (IsThemeColor(colorName)) { return GetThemeColor(colorName, themeColors, isDarkMode); }
	else if (colorName === "black" || colorName === "white" || colorName === "transparent")
	{
		const variantShade = colorName;
		return  GetVuetifyColorsByName("shades", variantShade);
	}
	// Caso contrário retorna a cor da palheta de cores do vuetify.
	return GetVuetifyColorsByName(colorName, variant);
};

// #endregion

// / <summary>
// /  Cores padrão do sistema, algumas nao estão presentes nos temas do Vuetify.
// / </summary>
const primary = "#516378"; // Azul AQTech.
const indigo = "#5C7BD9"; // Indigo
const secondary = "#F9FAFC"; // Gelo AQTech.
const accent = "#7EDC7E"; // Verde Claro AQTech.
const error = "#D40000"; // Vermelho Error.
const info = "#8B8B8B"; // Info Cinza.
const success = "#00CB00"; // Verde Succes.
const warning = "#F9DA14"; // Amarelo warning.
const orange = "#FF6347"; // Amarelo warning.

export {
	primary,
	secondary,
	accent,
	error,
	info,
	success,
	warning,
	indigo,
	orange
};
